<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      append-to-body
      title="选择行项"
      width="1200px">
    <vm-table
        ref="vmTable"
        :filter.sync="filter"
        module="basic"
        url="sAPPurchaseOrderDetails/plan"
        @select="select"
        @select-all="select">
      <div slot="toolbar">
        <el-button type="primary" @click="add()">新增</el-button>
      </div>
      <template slot="adSearch">
        <vm-search label="采购订单：">
          <el-input
              v-model.trim="filter.purchaseOrderNo"
              autosize
              placeholder="请输入采购单号"
              clearable/>
        </vm-search>
        <vm-search label="物料编号：">
          <el-input v-model.trim="filter.partNO" placeholder="请输入物料编号" clearable/>
        </vm-search>
        <vm-search label="出厂编号：">
          <el-input
              v-model.trim="filter.pCorderNo"
              placeholder="请输入出厂编号"
              autosize
              clearable/>
        </vm-search>
        <div>
          <vm-search label="到货日期：" style="width:200px">
            <div class="block">
              <el-date-picker
                  v-model="filter.deliveryDateBegin"
                  placeholder="请选择"
                  value-format="yyyy-MM-dd"
                  type="date"
                  style="width: 140px"/>
            </div>
          </vm-search>
          <vm-search label="至" style="width:200px;margin-left:15px">
            <div class="block">
              <el-date-picker
                  v-model="filter.deliveryDateEnd"
                  placeholder="请选择"
                  value-format="yyyy-MM-dd"
                  type="date"
                  style="width: 140px"/>
            </div>
          </vm-search>
        </div>
      </template>
      <el-table-column type="selection" align="center" width="55"/>
      <el-table-column
          prop="evaluate"
          align="center"
          label="采购订单"
          width="120"
          show-overflow-tooltip/>
      <el-table-column prop="rowNum" align="center" label="行号" width="100"/>
      <el-table-column
          prop="partNo"
          align="center"
          label="物料编号"
          width="140"
          show-overflow-tooltip/>
      <el-table-column
          prop="partNameSpec"
          align="left"
          label="物料描述"
          min-width="180"
          show-overflow-tooltip/>
      <el-table-column prop="deliveryDate" align="center" label="交货期" width="100">
        <template v-slot="scope">
          <span>{{scope.row.deliveryDate ? scope.row.deliveryDate.substring(0, 10) : ""}}</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="pCorderNo"
          align="center"
          label="出厂编号"
          width="140"
          show-overflow-tooltip/>
      <el-table-column prop="qty" align="center" label="数量" width="80"/>
      <el-table-column prop="planQty" align="center" label="已有计划数量" width="100"/>
      <el-table-column prop="actualQty" align="center" label="计划实收数量" width="100"/>
      <el-table-column prop="unit" align="center" label="单位" width="80"/>
    </vm-table>
  </el-dialog>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";

  export default {
    name: "PurchasePlanSelect",
    components: { VmTable, VmSearch },
    data() {
      return {
        dialogVisible: false,
        filter: {
        },
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.vmTable.getList(1);
        });
      },
      select(selection) {
        this.selection = selection;
      },
      add() {
        if(this.selection) {
          this.$emit("select", this.selection);
          this.selection = "";
          this.dialogVisible = false;
        }else {
          this.$message.error("请选择需要添加的行项！");
        }
        
      },
    },
  };
</script>